import Vue from "vue";

const _D = 2 ** 16

const _COLOR_MAP = [
    // Low temp
    [255, 255, 255], // White
    [0, 0, 0],       // Black
    [255, 0, 255],   // Magenta
    [0, 0, 255],     // Blue
    [0, 255, 0],     // Green
    [255, 0, 0],     // Red
    [255, 255, 0],   // Yellow
    [255, 255, 255], // White
    // High temp
]

const _COLOR_PERCENTAGE = 1 / (_COLOR_MAP.length - 1)

function mapIntensity(intensity) {
    const blockIdx = Math.floor(intensity / _COLOR_PERCENTAGE)  // the integer part represents how many blocks to skip
    const residualPercentage = intensity - (blockIdx * _COLOR_PERCENTAGE)  // remove the part represented of block
    const colorPercentage = residualPercentage / _COLOR_PERCENTAGE  // % of color of this block that will be filled
    const cTarget = _COLOR_MAP[blockIdx],
        cNext = intensity === 1 ? _COLOR_MAP[blockIdx] : _COLOR_MAP[blockIdx + 1]
    const deltaR = cNext[0] - cTarget[0],
        deltaG = cNext[1] - cTarget[1],
        deltaB = cNext[2] - cTarget[2]
    return [
        cTarget[0] + deltaR * colorPercentage,
        cTarget[1] + deltaG * colorPercentage,
        cTarget[2] + deltaB * colorPercentage,
    ]
}

function thermogramToImage(thermogram, width, height, minTempFloat, maxTempFloat) {
    let minTemp = _D, maxTemp = 0
    for (let i = 0; i < thermogram.length; i++) {
        const intensity = thermogram[i]
        if (intensity < minTemp) {
            minTemp = intensity
        }
        if (intensity > maxTemp) {
            maxTemp = intensity
        }
    }
    maxTemp -= minTemp
    const frameSize = width * height
    const image = new Uint8ClampedArray(frameSize * 4);
    const tempData = new Float32Array(frameSize)
    for (let i = 0; i < thermogram.length; i++) {
        const j = i * 4
        const intensity = (thermogram[i] - minTemp) / maxTemp
        tempData[i] = intensity * (maxTempFloat - minTempFloat) + minTempFloat
        const [r, g, b] = mapIntensity(intensity)
        image[j] = r
        image[j + 1] = g
        image[j + 2] = b
        image[j + 3] = 255
    }
    const data = new ImageData(image, width, height)
    return {data, tempData, minTempFloat, maxTempFloat, width, height}
}

function arrayBufferToImageData(buffer) {
    const headerSize = new Uint8Array(buffer, 0, 1)[0]
    const header = new DataView(buffer, 0, headerSize)
    const width = header.getUint16(10, true)
    const height = header.getUint16(12, true)
    const tempMin = header.getFloat32(38, true)
    const tempMax = _D * header.getFloat32(34, true) + tempMin
    let tempData = new Uint16Array(buffer, headerSize, width * height) // raw temp data
    return thermogramToImage(tempData, width, height, tempMin, tempMax)
}

export default {
    namespaced: true,
    state: {
        thermograms: [],
        neurals: [],
        loading: false,
        loadingNeural: false,
    },
    getters: {
        loading: state => state.loading || state.loadingNeural,
        thermograms: state => state.thermograms,
        neurals: (state) => (id) => {
            return state.neurals.find(thing => thing.id === id)
        }
    },
    mutations: {
        SET_LOADING: (state, data) => {
            state.loading = data
        },
        SET_LOADING_NEURAL_DATA:( state, data) => {
            state.loadingNeural = data
        },
        SET_THERMOGRAMS: (state, data) => {
            state.thermograms = data
        },
        SET_NEURAL_DATA: (state, data) => {
            state.neurals = data
        }
    },
    actions: {
        LOAD_THERMOGRAMS: async function ({commit}, payload) {
            if (!payload || !payload.length) return
            commit('SET_LOADING', true)
            const filePromises = payload.map(fileId => this.$api.files.getFile(fileId))
            Promise.all(filePromises)
                .then(responses => {
                    const thermograms = responses.map(
                        (response, it) => ({id: payload[it], ...arrayBufferToImageData(response.data)}))
                    commit('SET_THERMOGRAMS', thermograms)
                })
                .catch(response => {
                    Vue.prototype.$notify.error({
                        title: 'Ошибка загрузки термограмм 😕',
                        message: response.response.data.message,
                    });
                })
                .finally(() => commit('SET_LOADING', false))
        },
        LOAD_NEURAL_DATA: async function ({commit}, visitId) {
            if (!visitId) return

            commit('SET_LOADING_NEURAL_DATA', true)
            let filePromises

            this.$api.visit.getMlData(visitId)
                .then((response) => {
                    filePromises = response.data

                    const thermograms = filePromises.map((response) => {
                        if(!response || !response.data) return false
                        return {id: response.file_id, ...response.data}
                    })

                    commit('SET_NEURAL_DATA', thermograms)

                })
                .catch((response) => {
                    Vue.prototype.error({
                        title: 'Ошибка загрузки меток нейросети 😕',
                        message: response.response.data.message,
                    })
                })
                .finally(() => {
                    commit('SET_LOADING_NEURAL_DATA', false)
                })
        },

    },
}
